import { Component, HostListener, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { AppKitService } from '../../../services/appkitservice';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './sidebar.html',
  styleUrls: ['./sidebar.css'],
})
export class Sidebar {
  // walletAddress removed here to use the getter below

  // Sidebar state
  isSidebarOpen: boolean = true;
  isMobile: boolean = false;
  showLogoutModal: boolean = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    public appKitService: AppKitService,
    private cdr: ChangeDetectorRef
  ) {
    this.checkScreen();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreen();
  }

  checkScreen() {
    this.isMobile = window.innerWidth < 768;
    this.isSidebarOpen = !this.isMobile;
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  isActive(paths: string[]): boolean {
    return paths.some(path => this.router.url.includes(path));
  }

  get walletAddress(): string | null {
    return this.appKitService.getSafeWalletAddress();
  }

  async ngOnInit() {
    await this.appKitService.waitForInitialization();
  }

  async connectWallet() {
    await this.appKitService.connectWallet();
  }

  /** Open logout confirmation modal */
  openLogoutModal(event?: Event): void {
    if (event) event.preventDefault();
    this.showLogoutModal = true;
  }

  /** Close logout confirmation modal */
  closeLogoutModal(): void {
    this.showLogoutModal = false;
  }

  onLogout(): void {
    this.showLogoutModal = false;

    // 1. Clear Local Storage
    localStorage.removeItem('token');

    // 2. Disconnect wallet if possible
    if (this.appKitService.disconnect) {
      this.appKitService.disconnect();
    }

    // 4. Force UI Refresh
    this.cdr.detectChanges();

    this.toastr.success('Logged out successfully');
    this.router.navigate(['/login']);
  }
}
